import { Module, VuexModule, Mutation } from 'vuex-module-decorators';

export interface ISbsState {
    token: string | null;
}

@Module({ name: 'sbs' })
export class SbsState extends VuexModule implements ISbsState {
    token: string | null = null;

    @Mutation
    public clearToken() : void {
        this.token = null;
    }

    @Mutation
    public setToken(token: string): void {
        this.token = token;
    }
}